import * as client from "_graphql-types";
import { filterSortPage } from "../DataProvider";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InvestmentRiskInvestmentSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    investmentRiskInvestmentList: { items: data, total },
  } = await sdk.getInvestmentRiskInvestmentList(
    filterSortPage({
      filter,
      sort,
      pagination,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
export const investmentRiskInvestment = types.dataProvider({
  getList,
});
